define('notifications_profile.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('notifications_profile', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"notifications-profile\"><div data-view=\"ProfileChanges.Notifications\"></div></div> ";
},"useData":true}, 'extensions/UnlockCommerce/Summit/3.6.0/', 'extensions/UnlockCommerce/Summit/3.6.0/', Handlebars);
});